/**
 * Accepts an array of objects and converts the object keys to column headers
 * @param arr Array of objects
 * @returns a CSV content string
 */
export function getCSV(arr: Record<string, unknown>[]) {
  const keys = Object.keys(arr[0]);

  let result = '';
  result += keys.join(',');
  result += '\n';

  for (const item of arr) {
    for (const [index, key] of keys.entries()) {
      result += item[key] + (index < keys.length - 1 ? ',' : '');
    }

    result += '\n';
  }

  return result;
}

/**
 * @param arr Array of objects
 * @returns a CSV document string
 */
export function getCSVDocumentString(arr: Record<string, unknown>[]) {
  const csv = 'data:text/csv;charset=utf-8,' + getCSV(arr); //Creates CSV File Format
  return encodeURI(csv); //Links to CSV
}
